import { useState } from 'react';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined';
import AddIcon from '@mui/icons-material/Add';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditEntryModal from './editinventory';
import DeleteEntryModal from './deleteentry';

const CardView = ({ setAddEntryModal,fetchinventry, setLoading, data }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [activeFilter, setActiveFilter] = useState('All');
const [editModal, setEditModal] = useState(false);
const [selectedItem, setSelectedItem] = useState(null);
const [deleteModal, setDeleteModal] = useState(false);
  const colorPalette = [
    { bg: '#DBEAFE', text: '#193CB8' },
    { bg: '#F3E8FF', text: '#6E11B0' },
    { bg: '#DBEAFE', text: '#016630' },
    { bg: '#FEF3C6', text: '#973C00' },
    { bg: '#FFE2E2', text: '#372AAC' },
    { bg: '#CBFBF1', text: '#005F5A' },
    { bg: '#FCE7F3', text: '#A3004C' },
  ];

  // Create context counts
  const contextCounts = {};
  data.forEach(item => {
    const key = item?.associated_order_context;
    if (key) {
      contextCounts[key] = (contextCounts[key] || 0) + 1;
    }
  });
  const uniqueContexts = Object.keys(contextCounts);

  // Filter logic
  const filteredData = data.filter((item) => {
    if (searchTerm) {
      return (
        item?.item_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.ndc_number?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    } else if (activeFilter !== 'All') {
      return item?.associated_order_context === activeFilter;
    }
    return true;
  });

  return (
    <div className="p-4 space-y-4">
      <div className="rounded-[12.75px] border border-black/[0.01] bg-white shadow p-4">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <div className="text-[#0A0A0A] text-sm font-medium">Inventory</div>
          <div className="flex gap-2">
            <button className="flex items-center gap-1 rounded-[6.75px] bg-[#F3F4F6] text-xs font-semibold px-3 py-1 text-[#0A0A0A]">
              <FilterAltOutlinedIcon style={{ fontSize: 16 }} />
              Category
              <KeyboardArrowDownOutlinedIcon style={{ fontSize: 16, color: '#717182' }} />
            </button>
          </div>
        </div>

        {/* Filter Buttons */}
        <div className="font-bold text-start text-xs mb-2">Filter By Type</div>
        <div className="rounded-[8.75px] font-semibold bg-[rgba(236,236,240,0.30)] p-2 flex flex-wrap gap-2">
          <button
            onClick={() => setActiveFilter('All')}
            className={`rounded-[6.75px] text-xs font-semibold px-3 py-1 ${
              activeFilter === 'All' ? 'bg-[#09090B] text-white' : 'bg-gray-200 text-black'
            }`}
          >
            All ({data.length})
          </button>

          {uniqueContexts.map((context, index) => {
            const color = colorPalette[index % colorPalette.length];
            const isActive = activeFilter === context;
            return (
              <button
                key={context}
                onClick={() => {
                  setActiveFilter(context);
                  setSearchTerm('');
                }}
                className="rounded-[6.75px] text-xs font-semibold px-3 py-1"
                style={{
                  backgroundColor: isActive ? '#09090B' : color.bg,
                  color: isActive ? '#FFFFFF' : color.text,
                }}
              >
                {context} ({contextCounts[context]})
              </button>
            );
          })}
        </div>

        {/* Search + Add */}
        <div className="flex justify-between items-center mt-4">
          <div className="flex items-center gap-2">
            <div className="flex items-center gap-2 rounded-[6.75px] min-w-[250px] bg-[#DBEAFE] px-2 py-2">
              <SearchOutlinedIcon style={{ fontSize: 16, color: '#717182' }} />
              <input
                type="text"
                placeholder="Search inventory..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setActiveFilter('All'); // Reset filter when searching
                }}
                className="bg-transparent outline-none text-xs w-full pr-1 text-[#0A0A0A] placeholder-[#717182]"
              />
            </div>
            <button
              className="outline-none focus:outline-none"
              onClick={() => setSearchTerm('')}
            >
              <SyncOutlinedIcon style={{ fontSize: 18, color: '#0A0A0A' }} />
            </button>
          </div>
          <button
            onClick={() => setAddEntryModal(true)}
            className="flex font-semibold items-center gap-1 rounded-[6.75px] bg-[#09090B] text-xs px-3 py-1 text-white"
          >
            <AddIcon style={{ fontSize: 16 }} />
            Add New Item
          </button>
        </div>

        {/* Card Grid */}
        <div className="max-h-[600px] overflow-y-auto custom-scrollbar mt-6 pr-2">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {filteredData.map((item, index) => (
              <div
                key={item.id}
                className="rounded-[12.75px] border border-black/[0.01] bg-white shadow-[0_0_4px_0_rgba(0,0,0,0.25)] p-4 flex flex-col justify-between min-h-[230px]"
              >
                <div className="space-y-1">
                  <div className="flex justify-between items-start">
                    <div className="text-sm font-semibold text-[#0A0A0A]">{item?.item_name}</div>
                    <span className="text-[10px] border border-[#717182] font-semibold rounded-full px-2 py-[1px]">
                      {item?.associated_order_context || ''}
                    </span>
                  </div>

                  <div className="text-[10px] text-[#6B7280] text-start">
                    {item?.ndc_number}
                  </div>

                  <div className="flex items-center justify-between">
                    <div className="text-[11px] text-[#0A0A0A] font-medium mt-2 text-start">
                      Quantity
                    </div>
                    <span
                      className={`text-xs font-semibold rounded-full px-2 py-[2px] float-right
                        ${
                          item?.total_quantity < 50
                            ? 'bg-[#FEF3C6] text-[#973C00]'
                            : 'bg-[#DBEAFE] text-[#016630]'
                        }`}
                    >
                      {item?.total_quantity}
                    </span>
                  </div>

                  <div className="relative w-full h-[6px] bg-[#E5E7EB] rounded-full mt-[2px]">
                    <div
                      className="absolute top-0 left-0 h-[6px] bg-black rounded-full"
                      style={{ width: `${Math.min(item?.total_quantity, 100)}%` }}
                    />
                  </div>

                  <div className="grid grid-cols-2 gap-2 mt-4 text-[11px]">
                    <div className="text-left">
                      <div className="text-[#6B7280]">Last Entered:</div>
                      <div className="text-[#0A0A0A] font-semibold">{item.date}</div>
                    </div>
                    <div className="text-left">
                      <div className="text-[#6B7280]">Lot Number:</div>
                      <div className="text-[#0A0A0A]">
                        {item?.primary_lot_number ?? '-'}
                      </div>
                    </div>
                    <div className="text-left">
                      <div className="text-[#6B7280]">Current Lot:</div>
                      <div className="text-[#0A0A0A] font-semibold">
                        {item.lot_unit ?? '—'} units
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex justify-between items-center pt-3 mt-auto">
           <EditOutlinedIcon
  className="cursor-pointer"
  style={{ fontSize: 16, color: '#155DFC' }}
  onClick={() => {
    setSelectedItem(item);
    setEditModal(true);
  }}
/>

                  <DeleteOutlineOutlinedIcon
  className="text-red-500 cursor-pointer"
  style={{ fontSize: 16 }}
  onClick={() => {
    setSelectedItem(item);
    setDeleteModal(true);
  }}
/>

                </div>
              </div>
            ))}
            {filteredData.length === 0 && (
              <div className="col-span-full text-sm text-center text-gray-500">No results found.</div>
            )}
          </div>
        </div>
      </div>
      {editModal && selectedItem && (
  <EditEntryModal
    setEditModal={setEditModal}
    selectedItem={selectedItem}
    fetchInventory={fetchinventry}
    setLoading={setLoading}
  />
)}
{deleteModal && selectedItem && (
  <DeleteEntryModal
    setDeleteModal={setDeleteModal}
    selectedItem={selectedItem}
    fetchInventory={fetchinventry}
    setLoading={setLoading}
  />
)}

    </div>
  );
};

export default CardView;
